import React, {useState, useEffect} from 'react';
import { useCookies } from "react-cookie";

export default function Astuce() {

    const [cookies, setCookie, removeCookie] = useCookies(["token"]);
    const [astuce, setAstuce] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const decodeToken = (token) => {
        try {
            const payload = token.split(".")[1];
            return JSON.parse(atob(payload));
        } catch {
            return null;
        }
    };

    const [user, setUser] = useState(null);

    useEffect(() => {
        if (!cookies.token) return;

        const decoded = decodeToken(cookies.token);
        setUser(decoded); // contient { id, username, role, ... }
    }, [cookies.token]);

    async function loadAstuce(force) {
        try {
            setLoading(true);
            setError(null);

            const res = await fetch("https://api.industriegaming.fr/api/garden/astuce" + (force ? "?force=1" : ""), {
                headers: {
                    "Authorization": "Bearer " + cookies.token,
                }
            });

            const data = await res.json();

            if (data.error) {
                setError(data.error);
            } else {
                setAstuce(data.astuce);
            }
        } catch (err) {
            setError("Impossible de récupérer l’astuce.");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadAstuce(false);
    }, []);

    return (
        <div className="card">
            <div className="card-header">
                <span className="card-title">Astuce du jour 🍅</span>
                {user?.role === "Admin" && (
                    <button
                        className="refresh-btn"
                        onClick={() => loadAstuce(true)}
                        disabled={loading}
                    >
                        {loading ? "Mise à jour..." : "Refresh"}
                    </button>
                )}
            </div>

            <div style={{width: "100%", height: 250}} className="astuce-card">
                {loading && <p>Chargement...</p>}
                {error && <p style={{color: "red"}}>{error}</p>}
                {!loading && !error && <p>{astuce}</p>}
            </div>
        </div>
    );
}
